
import { defineComponent, SetupContext } from "vue";
import NativeClient from "@/client/native-client";

export default defineComponent({
  name: "PantryOpticalAxisCompleteDialog",
  props: {
    /** ダイアログのアクティブ状態 (true: 活性、false: 非活性) */
    isShowDialog: {
      type: Boolean,
      default: false
    },
  },
  setup(props, context: SetupContext) {
    const MESSAGE_TOP = "一度ドアを開け閉めすることで<br>カメラに設定が反映されます。<br>(反映に少し時間がかかります。)"
    const MESSAGE_BOTTOM = "次回以降の撮影画像に設定が反映されます。"
    const clickButton = () => {
      context.emit("negative-click");
    };
    return {
      clickButton,
      MESSAGE_TOP,
      MESSAGE_BOTTOM
    };
  }
});
